import React, { Component } from 'react'
import './styles.scss';
import PrintIcon from '@mui/icons-material/Print';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

class ClickableBox extends Component {
    handleClick = (externalLink) => {
        window.open(
            this.props.externalLink,
            '_blank'
        );
      };
    render() {
      return (
        // eslint-disable-next-line no-restricted-globals
        <div className='clickableBoxMain' onClick={this.handleClick}>
            {this.props.box === 'whatsapp' && <>
            <WhatsAppIcon className='clickableBoxIcon'/>
            <div className='clickableBoxText'>WhatsApp</div>
            </>
            }
            {this.props.box === 'printImages' && <>
            <PrintIcon className='clickableBoxIcon'/>
            <div className='clickableBoxText'>הדפסת תמונות</div>
            </>
            }
            {this.props.box === 'createAlbum' && <>
            <PhotoLibraryIcon className='clickableBoxIcon'/>
            <div className='clickableBoxText'>אלבום דיגיטלי</div>
            </>
            }

        </div>
      )
    }
  }

export default ClickableBox